module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-pedo"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (_vm.props && !_vm.loading) ? _c('div', [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _c('transition-group', {
    attrs: {
      "name": "crossfade",
      "tag": "div"
    }
  }, [_c('Exam', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#exams"),
      expression: "$store.state.route.hash === \"#exams\""
    }],
    key: "1",
    attrs: {
      "props": _vm.props.acf.custom_exam
    }
  }), _c('Nutrition', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#nutrition"),
      expression: "$store.state.route.hash === \"#nutrition\""
    }],
    key: "2",
    attrs: {
      "props": _vm.props.acf.custom_nutrition
    }
  }), _c('Care', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#other"),
      expression: "$store.state.route.hash === \"#other\""
    }],
    key: "3",
    attrs: {
      "props": _vm.props.acf.custom_care
    }
  }), _c('Caries', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#children-caries"),
      expression: "$store.state.route.hash === \"#children-caries\""
    }],
    key: "4",
    attrs: {
      "props": _vm.props.acf.custom_caries
    }
  }), _c('Fillings', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#fillings"),
      expression: "$store.state.route.hash === \"#fillings\""
    }],
    key: "5",
    attrs: {
      "props": _vm.props.acf.custom_fillings
    }
  }), _c('Nitrous', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#nitrous"),
      expression: "$store.state.route.hash === \"#nitrous\""
    }],
    key: "6",
    attrs: {
      "props": _vm.props.acf.custom_nitrous
    }
  }), _c('BabyTeeth', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#baby-teeth"),
      expression: "$store.state.route.hash === \"#baby-teeth\""
    }],
    key: "7",
    attrs: {
      "props": _vm.props.acf.custom_baby_teeth
    }
  }), _c('Nitrous', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#oral-habits"),
      expression: "$store.state.route.hash === \"#oral-habits\""
    }],
    key: "8",
    attrs: {
      "props": _vm.props.acf.custom_habits
    }
  }), _c('PedoFaq', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#pedo-faq"),
      expression: "$store.state.route.hash === \"#pedo-faq\""
    }],
    key: "9",
    attrs: {
      "props": _vm.props.acf.custom_faq
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c651dba","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/pedo/pedo.pug
// module id = 698
// module chunks = 1